"use client";

import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="213823" className="hidden md:flex gap-8">
        <div className="h-4 w-16 animate-pulse bg-muted rounded-sm" />
        <div className="h-4 w-16 animate-pulse bg-muted rounded-sm" />
        <div className="h-4 w-16 animate-pulse bg-muted rounded-sm" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-8">
        {menuItems.filter(item => item.label !== 'CardDetail Page' && item.label !== 'Blank Page').map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="relative flex items-center py-2 font-default text-[14px] font-medium uppercase tracking-widest text-foreground transition-colors hover:text-secondary after:absolute after:bottom-0 after:left-1/2 after:h-[1px] after:w-0 after:-translate-x-1/2 after:bg-secondary after:transition-all after:duration-300 hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="p-4 text-sm font-default text-muted-foreground">Carregando...</div>;
  }
  return <div className="flex flex-col gap-6 mt-16 px-4">
      {menuItems.filter(item => item.label !== 'CardDetail Page' && item.label !== 'Blank Page').map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="font-default text-lg font-medium uppercase tracking-widest text-foreground transition-colors hover:text-secondary">
          {item.label}
        </Link>)}
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (hashPart === '') {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            return;
          }
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="navegação-principal" className={`sticky top-0 z-50 w-full transition-all duration-500 ${isScrolled ? "bg-background/80 backdrop-blur-[12px] border-b border-border shadow-sm" : "bg-background border-b border-transparent"}`}>
      <div className="container mx-auto px-6 md:px-12 flex h-40 items-center justify-between">
        {}
        <Link to="/" className="flex items-center z-10 shrink-0">
          <img src="https://able-narwhal.10web.cloud/wp-content/uploads/2026/04/ChatGPT-Image-16-de-abr.-de-2026-12_56_24.png" alt="KG VIAGENS" className="object-contain bg-transparent !w-[250px] !h-[138px]" />
        </Link>

        {}
        <div className="hidden md:flex flex-1 justify-center text-foreground">
          <MenuProvider menu_id="43">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="hidden md:block w-[100px] shrink-0" />

        {}
        <div className="md:hidden flex items-center">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="text-foreground hover:bg-transparent hover:opacity-70" aria-label="Abrir menu">
                <Menu className="size-6" strokeWidth={1.5} />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-background border-l-border w-[300px] sm:w-[400px]">
              <MenuProvider menu_id="43">
                <MobileMenuConsumer />
              </MenuProvider>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </section>;
}